import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { AppUpdateService } from './core/services/app-update.service';
import {
  RemoteConfigService,
  UNDER_CONSTRUCTION_CONFIG_KEY,
} from './core/services/remote-config.service';
import { AppUpdateComponent } from './shared/app-update/app-update.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppUpdateComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly appUpdateService = inject(AppUpdateService);
  private readonly router = inject(Router);
  private readonly remoteConfig = inject(RemoteConfigService);
  private readonly underConstruction = this.remoteConfig.booleanSignal(
    UNDER_CONSTRUCTION_CONFIG_KEY,
    false,
  );

  constructor() {
    void this.remoteConfig.initialize();

    effect(() => {
      const underConstruction = this.underConstruction() === true;
      const onConstructionPage = this.router.url.startsWith('/under-construction');

      if (underConstruction && !onConstructionPage) {
        void this.router.navigateByUrl('/under-construction');
        return;
      }

      if (this.remoteConfig.ready() && !underConstruction && onConstructionPage) {
        void this.router.navigateByUrl('/');
      }
    });
  }
}
